class ProductVideo {

    constructor() {
        this.cacheDom();
        this.bindEvents();
        this.resize();
    }

    cacheDom() {
        this.elementWatcher = null;
        this.container = document.querySelector('.c-productVideo');
        this.iframe = document.querySelector('.c-productVideo__player');
        this.poster = document.querySelector('.c-productVideo__poster');
        this.btn = document.querySelector('.c-productVideo__playerBtn');

        this.videoElement = document.querySelectorAll('.c-sideBySide__video');
    }

    bindEvents() {
        if (this.elementsExist() === true) {
            const player = new Vimeo.Player(this.iframe);

            this.btn.addEventListener('click', (e) => {
                this.poster.classList.toggle('c-productVideo__poster--hidden');
                this.btn.classList.toggle('c-productVideo__playerBtn--hidden');
                player.play();
            });

            player.on('ended', () => {
                this.poster.classList.toggle('c-productVideo__poster--hidden');
                this.btn.classList.toggle('c-productVideo__playerBtn--hidden');
            });
        }

        if (_.isNull(this.videoElement) === false) {

            Array.prototype.forEach.call(this.videoElement, (el, i) => {
                const poster = el.querySelector('.c-video__poster');
                const btn = el.querySelector('.c-video__playBtn');
                const iframe = el.querySelector('.c-video__player');

                const player = new Vimeo.Player(iframe);
                player.setAutopause(false);

                btn.addEventListener('click', (e) => {
                    player.play();
                    btn.classList.add('is-playing');
                    poster.classList.add('is-playing');
                });

                player.on('pause', () => {
                    btn.classList.remove('is-playing');
                    poster.classList.remove('is-playing');
                });

                player.on('ended', () => {
                    btn.classList.remove('is-playing');
                    poster.classList.remove('is-playing');
                });
            });

        }
    }

    resize() {
        if (this.elementsExist() === true) {
            if (_.isUndefined(Breakpoint.grpInt) === false) {
                if (Breakpoint.grpInt > 3) {
                this.initScrollVideo();
                }
            }
        }
    } 
    
    initScrollVideo() {
        const elementWatcher = scrollMonitor.create(this.container);
        const player = new Vimeo.Player(this.iframe);

        elementWatcher.fullyEnterViewport(() => {
            //this.poster.classList.add('c-productVideo__poster--hidden');
//            this.btn.classList.add('c-productVideo__playerBtn--hidden');
//            player.play();
//        
//            player.on('ended', () => {
//                this.poster.classList.remove('c-productVideo__poster--hidden');
//                this.btn.classList.remove('c-productVideo__playerBtn--hidden');
//            });
        });
    }

    elementsExist() {
        let exist = false;

        if (_.isNull(this.container) === false && _.isNull(this.iframe) === false && _.isNull(this.poster) === false && _.isNull(this.btn) === false) {
            exist = true;
        } else {
            exist = false;
        }

        return exist;
    }
}

module.exports = ProductVideo;